const config = {
  development: {
    apiBaseUrl: 'http://localhost:5001',
  },
  production: {
    apiBaseUrl: 'https://panpals-backend-production.up.railway.app',
  },
};

const environment = process.env.NODE_ENV || 'development';
export const NOTIFICATIONS_PAGE_SIZE = 10;

export const apiConfig = config[environment];
